import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useTranslation from '../../hooks/TranslationContext';

// defines
type Props = {
  className?: string,
  items?: any[],
  currentLink?: string
}

export default function PortalMobileFooterMenu({ className, items, currentLink }: Props) {
  const { t } = useTranslation();
  // const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const [selectedItemKey, setSelectedItemKey] = useState<string>("");
    const navigate = useNavigate();

  const onMenuItemClick = (item : any) => {
    navigate(item.link);
    onSelectedItemChange(item.link);
  }

  useEffect(()=> {
    onSelectedItemChange(currentLink)
  }, [currentLink])

  const onSelectedItemChange = (url? :string) => {
    if (!url) {
      url = "/portal";
    }
    const selectedItems = items?.filter(x => x.link === url);
    if (selectedItems?.length) {
      setSelectedItemKey(selectedItems[0].key)
    }
  }

  return (
    <footer className={`${className} w-full bg-white border-t border-gray-200`}>
      <div className="flex justify-around py-2">
        {
          items?.map(item => (
            <button key={item.key} className={`flex flex-col items-center ${item.key === selectedItemKey ? "selected" : ""}`} onClick={() => onMenuItemClick(item)}>
              {/* {item.icon} */}
              <icon className="text-2xl">{item.icon}</icon>
              <span className="text-xs">{t(item.label)}</span>
            </button>
          ))
        }
      </div>
    </footer>
  );
};
